<template>
    <el-dialog title="Indexer / Désindexer" v-loading="loader" :visible.sync="display" width="50%">
        <span>Indéxer / Désindexer les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formIndex" ref="form" :model="form">
            <el-form-item prop="indexed">
                <el-switch v-model="form.indexed" active-text="Indexé" inactive-text="Désindexé">
                </el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                indexed: false
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var indexed = this.form.indexed;
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                indexed,
                mode: 'index'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
